<template>
  <el-card v-loading="loading" class="pro-detail">
    <!-- 基本信息 -->
    <el-alert
      class="info-title"
      title="核注清单导出"
      type="info"
      :closable="false"
    >
    </el-alert>
    <el-row class="info">
      <el-row>
        <el-col class="title" :span="24">
          <h2>导入运单文件须知</h2>
          <el-tag type="info" effect="dark"> 注意 </el-tag>
        </el-col>
        <el-col :span="24">
          <ul class="oms-list">
            <li>
              1.请选择要导入的Excel文件,文件格式为.xls
              <el-link
                :href="templateUrl"
                download
                type="primary"
                >【模板下载】
              </el-link>
            </li>
            <li>2.导入条目数限制为每次50条运单单,请注意导入的运单数量</li>
            <li>3.时间字段的格式为yyyy-MM-dd HH:mm:ss,金额字段单位为元</li>
            <li>4.请不要调换Excel的列顺序</li>
            <li>
              5.导入如果提示行校验不通过，请检查对应行：必填字段是否都填写,日期格式日否正确
            </li>
          </ul>
        </el-col>
        <el-col :span="24">
          <div class="pampas-import-statistics">
            <div>导入统计:</div>
            <el-badge :value="statisticObj.importTotal" class="item">
              需要导出数量
            </el-badge>
            <el-badge :value="statisticObj.invalidRowNum" class="item">
              校验不通过数量
            </el-badge>
            <!--                        <el-badge :max="99"  :value="statisticObj.importSuccess" class="item">-->
            <!--                            导入成功数量-->
            <!--                        </el-badge>-->
            <!--                        <el-badge :max="99"  :value="statisticObj.importFail" class="item">-->
            <!--                            导入失败数量-->
            <!--                        </el-badge>-->
          </div>
        </el-col>
        <el-col :span="24">
          <div class="pampas-import-file-container">
            <label>选择要导入文件:</label>
            <div class="pampas-file-upload">
              <input
                :title="localFilePath"
                readonly
                type="text"
                :value="localFilePath"
              />

              <el-upload
                class="avatar-uploader"
                action="/file.api"
                accept=".xls, .xlsx"
                :show-file-list="false"
                :data="uploadData"
                :name="uploadName"
                :on-success="handleAvatarSuccess"
              >
                <el-button size="mini" type="primary">上传</el-button>
              </el-upload>
              <el-button
                v-on:click="importOrderData"
                v-show="showImportBtn"
                size="mini"
                type="primary"
              >
                导出核注清单
              </el-button>
              <el-upload
                class="avatar-uploader"
                action="/file.api"
                accept=".xls, .xlsx"
                :show-file-list="false"
                :data="uploadData"
                :name="uploadName"
                :on-success="handleAvatarSuccess2"
              >
                <el-button size="mini" type="primary">导出账册运单</el-button>
              </el-upload>
              <el-upload
                class="avatar-uploader"
                action="/file.api"
                accept=".xls, .xlsx"
                :show-file-list="false"
                :data="uploadData"
                :name="uploadName"
                :on-success="handleAvatarSuccess3"
              >
                <el-button size="mini" type="primary">运单预览</el-button>
              </el-upload>
              <!-- <el-button v-on:click="importBooksOrder" size="mini" type="primary">
                                导出账册运单
                            </el-button> -->
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="pampas-import-preview">
            <label>导入结果信息：</label>
            <div>
              <p>导入预览：</p>
            </div>
          </div>
          <div>
            <element-table
              headerClassName="stock-table"
              :rowClassName="rowClassName"
              :data="excelRows"
              :columns="excelColumns"
              :loading="loading"
              border
            ></element-table>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import Page from "@/mixin/Page";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      templateUrl: process.env.BASE_URL + "templates/运单号导入模板.xls",
      showImportBtn: false,
      localFilePath: "Choose File",
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      excelRows: [],
      statisticObj: {
        importTotal: 0,
        invalidRowNum: 0,
        importSuccess: 0,
        importFail: 0,
      },
      filUrl: "",
      excelColumns: [
        {
          title: "出库单号",
          key: "bizId",
          minWidth: 150,
          align: "center",
        },
        {
          title: "运单号",
          key: "mailNo",
          minWidth: 150,
          align: "center",
        },
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          minWidth: 150,
          align: "center",
        },
        {
          title: "渠道名",
          key: "merchantName",
          minWidth: 150,
          align: "center",
        },
        {
          title: "清单编号",
          key: "ccbBizId",
          minWidth: 150,
          align: "center",
        },
        {
          title: "申报状态",
          key: "ccbState",
          minWidth: 150,
          align: "center",
        },
        {
          title: "错误信息",
          key: "errorMsg",
          minWidth: 150,
          align: "center",
          render: (h, param) => {
            let msg = (param.row || {}).errorMsg;
            let prop = { disabled: msg == null };
            return (
              <div>
                <el-tooltip
                  {...prop}
                  className="item"
                  effect="light"
                  placement="top"
                >
                  <div slot="content">{msg}</div>
                  <el-button>查看错误</el-button>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
    };
  },
  mixins: [Page],
  components: {
    ElementTable,
  },
  created() {
    //this.fetch();
  },
  mounted() {},
  methods: {
    ...mapActions("danding", ["orderSplitByChecklistOrderExist"]),
    rowClassName(param) {
      let row = param.row;
      if (row.errorMsg != null && row.errorMsg.trim().length > 0) {
        return "table-row-danger";
      }
      return "";
    },
    // 获取入库单详情
    importOrderData() {
      if (this.statisticObj.invalidRowNum > 0) {
        this.$message.error("请处理异常信息后再导出核注清单。");
        return;
      }
      let submitData = [];
      for (let i = 0; i < this.excelRows.length; i++) {
        let item = this.excelRows[i];
        if (item.errorMsg == null || item.errorMsg.trim().length === 0) {
          submitData.push(item);
        }
      }

      if (submitData.length <= 0) {
        this.$message.warning("没有一条有效数据");
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("submitNuclareBuildExcelTask", {
          request: JSON.stringify({ nuclareInfoItems: submitData }),
        })
        .then((res) => {
          this.loading = false;

          if (res.value) {
            this.showImportBtn = false;
            this.$alert("提交导出任务成功", "提示", {
              confirmButtonText: "前往下载",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    importBooksOrder() {
      if (this.filUrl === "") {
        this.$message.error("暂时没有数据");
        return;
      }
      if (this.statisticObj.invalidRowNum > 0) {
        this.$message.error("请处理异常信息后再导出清单。");
        return;
      }
      let submitData = [];
      for (let i = 0; i < this.excelRows.length; i++) {
        let item = this.excelRows[i];
        if (item.errorMsg == null || item.errorMsg.trim().length === 0) {
          submitData.push(item);
        }
      }

      if (submitData.length <= 0) {
        this.$message.warning("没有一条有效数据");
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("orderSplitByAccountBook", {
          fileUrl: this.filUrl,
        })
        .then((res) => {
          this.loading = false;
          if (res.value) {
            this.showImportBtn = false;
            this.$alert("提交导出任务成功", "提示", {
              confirmButtonText: "前往下载",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    toView(name) {
      this.$router.push({ name });
    },
    handleAvatarSuccess(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.filUrl = filUrl;
      this.loading = true;
      this.$store
        .dispatch("uploadNuclearNoteExcel", {
          fileUrl: filUrl,
        })
        .then((res) => {
          this.loading = false;
          this.showImportBtn = true;
          this.excelRows = res.nuclareInfoItems;
          this.statisticObj.importTotal = this.excelRows.length;
          this.statisticObj.invalidRowNum = this.excelRows.filter((item) => {
            return item.errorMsg != null && item.errorMsg.trim().length > 0;
          }).length;
          if (!res.success) {
            this.$message.error(res.msg);
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    handleAvatarSuccess2(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.$store
        .dispatch("orderSplitByAccountBook", {
          fileUrl: filUrl,
        })
        .then((res) => {
          this.loading = false;
          if (res.value) {
            this.showImportBtn = false;
            this.$alert("提交导出任务成功", "提示", {
              confirmButtonText: "前往下载",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    handleAvatarSuccess3(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.orderSplitByChecklistOrderExist({
        fileUrl: filUrl,
      })
        .then((res) => {
          this.loading = false;
          if (res.value) {
            this.$alert("提交导出任务成功", "提示", {
              confirmButtonText: "前往下载",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.el-table .table-row-danger {
  background: #f56c6c;
}

.pampas-file-upload {
  button {
    margin-left: 5px;
  }
}

.avatar-uploader {
  display: inline-block;
}

.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .info {
    padding: 10px 20px 30px;

    .title {
      line-height: 100%;

      h2 {
        display: inline-block;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
        background: #777777;
        color: #f8f8f8;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}

.oms-list {
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    margin: 0;
    padding: 6px 0;
    color: black;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
  }
}

.pampas-import-statistics {
  border-top: 2px solid #bccde6;
  margin-top: 15px;
  padding: 12px 0;
  font-weight: 600;

  & > div {
    margin: 0 10px;
    padding: 3px 0;
    color: #5a9fd6;
    position: relative;
    vertical-align: middle;
    display: inline-block;

    & > sup {
      position: relative !important;
      right: 0 !important;
      top: 0 !important;
      border: none !important;
      display: inline;
      vertical-align: text-bottom;
      background-color: #777777;
      border-radius: 100%;
      padding: 3px 5px;
      font-size: 12px;
    }
  }

  & > div:first-child {
    color: black;
  }
}

.pampas-import-file-container {
  padding: 20px;
  border-bottom: 1px solid #bccde6;
  border-top: 1px solid #bccde6;

  & > label {
    margin-right: 45px;
  }

  & > div {
    display: inline-block;

    & > input {
      outline: none;
      padding: 7px 8px;
      border-radius: 3px;
      border: 1px solid #d5d5d5;
      background-color: #eeeeee;
      color: #a5a5a5;
      margin-right: 15px;
      font-size: 12px;
    }
  }
}

.pampas-import-preview {
  & > div {
    & > p {
      text-indent: 2em;
      background-color: #f5f5f5;
      padding: 5px 0;
      border-bottom: 1px solid #bccde6;
      border-top: 1px solid #bccde6;
      font-weight: 700;
    }
  }
}
</style>
